import XhrLoader from "hlsjs_xhr_loader";
import { _createFakeXHRObject } from "./hlsjs-tools.js";
import abr from "../../../abrCustom.js";
// import _incRebuff from 'hls.js/src/controller/abr-controller.js'

export default function EBFragLoaderGenerator(lib, player, libConnected) {
  return class EBFragLoader extends XhrLoader {
    load(context, config, callbacks) {
      this.context = context;
      this.config = config;
      this.callbacks = callbacks;
      // this.stats = Stats
      this.stats = { trequest: performance.now(), retry: 0 };
      this.retryDelay = config.retryDelay;
        if (libConnected) {
          this._xhr(context.url, config, callbacks, config,player,abr);
        } else {
          this.loadInternal();
        }
    }
    _xhr(uri, options, callbacks, config,player, abr) {
      const { stats } = this;
      const { context } = this;
      const xhr = _createFakeXHRObject()
      // console.log("url requested", uri)
      xhr.responseType = context.responseType;
      stats.tfirst = 0;
      stats.loaded = 0;
      xhr.requestTime = Date.now();
      lib
        .getResource(uri)
        .then(response => {
          xhr.responseTime = Date.now();
          xhr.response = response.buffer;
          xhr.responseType = "arraybuffer";
          xhr.bytesReceived = response.byteLength || 0;
          xhr.roundTripTime = xhr.responseTime - xhr.requestTime;
          // console.log("roundtriptime",xhr.roundTripTime)
          xhr.bandwidth = Math.floor(
            (xhr.bytesReceived ) / (xhr.roundTripTime ),
          );
          // abr.abr.getBitrate(xhr.bandwidth)
          stats.bw = xhr.bandwidth * 8 * 1000
          // AbortController.setBitrate.add(xhr.bandwidth*8*1000)
          // console.log("bandwidth in bytes/ms",xhr.bandwidth)
          xhr.responseType = "arraybuffer";
          xhr.readyState = 4;
          xhr.status = 200;
          
          if (stats.tfirst === 0) {
            // stats.tfirst = Math.max(performance.now(), stats.trequest);
          }
          //essentially to make abr not work 
          // stats.tload = Math.max(stats.tfirst, performance.now());
          // stats.loaded = stats.total = 0

          stats.tload = Math.max(stats.tfirst, performance.now());
          stats.loaded = stats.total = xhr.bytesReceived 
          // console.log("stats",stats)
          
          try {
            if (!xhr.isAborted) {
              callbacks.onSuccess(
                { url: uri, data: response.buffer },
                this.stats,
                context,
                xhr,
              );
            }
          } catch (err) {
            console.warn(err);
            console.warn(err.stack);
          }
        })
        .catch(err => {
          console.log(`*ERR* :${uri}`);
          console.log(err);
          xhr.readyState = 1;
          xhr.timedout = true;
          this.context = context;
          this.config = config;
          this.callbacks = callbacks;
          this.loadInternal();
          callbacks.onError(
            { code: xhr.status, text: err.message },
            context,
            xhr,
          );
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/videoJSExtensions/easybroadcast/hlsjs-loader.js